export default class {

    constructor(google) {
        this.google = google
    }

    jsonToGmapObject(obj) {
        obj.routes.forEach((route) => {
            route.bounds = new this.google.maps.LatLngBounds(route.bounds.southwest, route.bounds.northeast)
            route.overview_path = this.google.maps.geometry.encoding.decodePath(route.overview_polyline.points)
            route.overview_polyline = route.overview_polyline.points
            route.legs.forEach((leg) => {
                leg.start_location = this.toLatLngObj(leg.start_location)
                leg.end_location   = this.toLatLngObj(leg.end_location)

                leg.steps.forEach((step) => {
                    step.start_location = this.toLatLngObj(step.start_location)
                    step.end_location   = this.toLatLngObj(step.end_location)
                    step.path = this.google.maps.geometry.encoding.decodePath(step.polyline.points)
                })
            })
        })

        obj.request.origin.location = this.toLatLngObj(obj.request.origin.location)
        obj.request.destination.location = this.toLatLngObj(obj.request.destination.location)
        obj.request.destination.location = this.toLatLngObj(obj.request.destination.location)

        // this method really convert the original data, so add a flag to only convert once
        obj.convertedGmap = true

        return obj
    }

    toLatLngObj(obj) {
        return new this.google.maps.LatLng(obj.lat, obj.lng)
    }

}
